<template>
  <b-form @submit.prevent="onSearch">
    <b-input-group class="mb-3 w-100 searcher">
      <b-form-input v-model="search.term" placeholder="Buscar..."></b-form-input>
      <b-input-group-append>
        <b-button variant="outline-info searcher-options" v-b-toggle.searcher-options>
          <i class="mdi mdi-dots-vertical"></i>
        </b-button>
        <b-button variant="info" type="submit">Buscar</b-button>
        <b-button v-if="!hideFilters" variant="outline-primary" @click="$emit('toggleFilters')">
          <i class="mdi mdi-filter-outline"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-collapse id="searcher-options" class="mt-2">
    <b-card>
      <b-form-checkbox-group
        v-model="checksOptions"
        @input="onChange"
        :options="searcherOptions"
      ></b-form-checkbox-group>
      <p class="text-italic mt-2 text-info" v-if="!search.fields.length">Si no seleccionas ninguna opcion, se buscará en todas.</p>
    </b-card>
  </b-collapse>
  </b-form>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    hideFilters: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    options: {
      immediate: true,
      handler (val) {
        this.checksOptions = val.map((el, index) => index)
        this.onChange(this.checksOptions)
      }
    }
  },
  computed: {
    searcherOptions () {
      return this.options.map((el, index) => {
        return {
          text: el.label,
          value: index
        }
      })
    }
  },
  data () {
    return {
      checksOptions: [],
      search: {
        term: '',
        fields: []
      }
    }
  },
  methods: {
    onChange (event) {
      const fields = []
      for (const index of event) {
        const check = this.options.at(index).key
        fields.push(check)
      }
      this.search.fields = fields.flat()
    },
    onSearch () {
      this.$emit('onSearch', this.search)
    }
  }
}
</script>

<style lang="sass" scoped>
  .searcher .input-group-append .btn
    padding: 0 1rem
    &.searcher-options
      padding: 0 .2rem
    i
      font-size: 1.4rem
</style>
